import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { getTokenFromStorage } from '@/utils/auth';
import { getClientCalendarSearch, type ClientCalendarSearchPage } from '@/api/beatlyApi';

/**
 * Fetches the next upcoming calendar event via GET /app/v2/client/calendar/search (page_size=1).
 */
export function useDashboardCalendarNextEvent() {
  const { user } = useAuth();
  const token = getTokenFromStorage();
  const enabled = Boolean(token && user?.is_client && user?.team?.team_id);

  return useQuery({
    queryKey: ['dashboard', 'calendar-next', user?.team?.team_id],
    enabled,
    staleTime: 60_000,
    queryFn: async (): Promise<ClientCalendarSearchPage> => {
      const authToken = token ?? '';
      const dateFrom = new Date(new Date().setHours(0, 0, 0, 0)).toISOString();
      return getClientCalendarSearch({ pageNumber: 0, pageSize: 1, dateFrom }, authToken);
    },
  });
}
